export default __webpack_public_path__ + "static/media/pen.419ab9c7.svg";